import { mergeTopolJsonIntoCampaignMetadata } from './marketingCampaignMetadata';

export function isTopolTemplateRow(row) {
    const jsonRaw = row?.strJson;
    const jsonStr = typeof jsonRaw === 'string' ? jsonRaw.trim() : '';
    return jsonStr.startsWith('{') || jsonStr.startsWith('[');
}

/**
 * Maps a marketing email template row to campaign design fields (SET_TITLE_AND_HTML payload).
 */
export function buildCampaignDesignFromTemplateRow(
    row,
    { campaignTitle = '', campaignMetadata = null } = {},
) {
    const looksLikeTopol = isTopolTemplateRow(row);
    const html = row?.strBody ?? '';

    return {
        title: campaignTitle,
        html,
        metadata: looksLikeTopol
            ? mergeTopolJsonIntoCampaignMetadata(campaignMetadata, row?.strJson)
            : null,
    };
}
